import React from 'react';
import { FiXCircle, FiAlertCircle } from 'react-icons/fi';

interface ErrorDisplayProps {
  error: string | Error | null;
  onDismiss?: () => void;
  className?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onDismiss, className = '' }) => {
  if (!error) return null;

  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div className={`p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 flex items-start gap-3 ${className}`}>
      <FiAlertCircle className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="font-medium">Error</p>
        <p className="text-sm break-words">{errorMessage}</p>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="flex-shrink-0 text-red-500 hover:text-red-700 transition-colors"
          aria-label="Dismiss error"
        >
          <FiXCircle className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

